import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// --- Interfaces ---
import type { IParameters } from '@interfaces/parameters';

export const INITIAL_STATE: IParameters = {};

@Injectable({
	providedIn: 'root',
})
export class ParametersStore {
	private _parametersState = new BehaviorSubject<IParameters>(INITIAL_STATE);
	readonly parametersState$ = this._parametersState.asObservable();

	constructor() {}

	updateParameters(parameters: IParameters) {
		const state = this._parametersState.value;

		const data = {
			...state,
			...parameters,
		};

		this._parametersState.next(data);

		return this._parametersState.asObservable();
	}
}
